import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {API_URL} from '../constants';
import {Blog, BlogComment, BlogDraft, BlogPage} from '../models/blog.model';

@Injectable({
    providedIn: 'root',
})
export class BlogApiService {
    private apiUrl = `${API_URL}` + 'blogs';

    constructor(private http: HttpClient) {
    }

    getFeed(cursor?: string | null, limit = 10, authorId?: string): Observable<BlogPage> {
        let params = new HttpParams().set('limit', limit);
        if (cursor) params = params.set('cursor', cursor);
        if (authorId) params = params.set('authorId', authorId);
        return this.http.get<BlogPage>(this.apiUrl, {params});
    }

    get(id: string): Observable<Blog> {
        return this.http.get<Blog>(`${this.apiUrl}/${id}`);
    }

    create(draft: BlogDraft): Observable<Blog> {
        return this.http.post<Blog>(this.apiUrl, draft);
    }

    update(id: string, draft: BlogDraft): Observable<Blog> {
        return this.http.put<Blog>(`${this.apiUrl}/${id}`, draft);
    }

    delete(id: string): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }

    hide(id: string, reason?: string): Observable<Blog> {
        return this.http.post<Blog>(`${this.apiUrl}/${id}/hide`, {reason});
    }

    unhide(id: string): Observable<Blog> {
        return this.http.post<Blog>(`${this.apiUrl}/${id}/unhide`, {});
    }

    uploadCover(id: string, file: File): Observable<{ coverImageUri: string }> {
        const form = new FormData();
        form.append('file', file);
        return this.http.post<{ coverImageUri: string }>(`${this.apiUrl}/${id}/cover`, form);
    }

    like(id: string): Observable<void> {
        return this.http.post<void>(`${this.apiUrl}/${id}/like`, {});
    }

    unlike(id: string): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}/like`);
    }

    getComments(id: string): Observable<BlogComment[]> {
        return this.http.get<BlogComment[]>(`${this.apiUrl}/${id}/comments`);
    }

    addComment(id: string, text: string): Observable<BlogComment> {
        return this.http.post<BlogComment>(`${this.apiUrl}/${id}/comments`, {text});
    }

    deleteComment(id: string, commentId: string): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}/comments/${commentId}`);
    }
}
